import { PERMISSIONS_VIEWS, USER_ROLES } from "config/userPermissions";
import EventListView from "../components/EventListView/EventListView";
import ManualLoadingForm from "../components/FormCreateEvent/ManualLoadingForm/ManualLoadingForm";
import MassiveLoadingForm from "../components/FormCreateEvent/MassiveLoadingForm/MassiveLoadingForm";
import EventAttendance from "../components/EventAttendance/EventAttendance";
import EventDetailView from "../components/EventDetailView/EventDetailView";

const { EVENTOS } = PERMISSIONS_VIEWS;

export const EVENTS_MODULES = [
	{
		id: EVENTOS.LISTADO_EVENTOS,
		path: "",
		View: EventListView,
	},
	{
		id: EVENTOS.CARGA_MANUAL,
		path: "carga-manual/*",
		View: ManualLoadingForm,
	},
	{
		id: EVENTOS.CARGA_MASIVA,
		path: "carga-masiva",
		View: MassiveLoadingForm,
	},
	{
		id: EVENTOS.ASISTENCIA,
		path: "asistencia",
		View: EventAttendance,
	},
];
export const EVENTS_EXTRA_MODULES = [
	{
		id: "EVENTOS_DETALLE",
		roles: [
			USER_ROLES.SUPERADMIN,
			USER_ROLES.EVENTOS_COORDINADOR,
			USER_ROLES.EVENTOS_DOCENTE,
			USER_ROLES.REF_ACAD_TUTOR,
			USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS
		],
		path: "detalle",
		View: EventDetailView,
	},
];
